<div class="authentication-container" [class.bg-cb]="isCasasBahia" [class.bg-pf]="!isCasasBahia">
  <div *ngIf="!isCasasBahia" class="mobile-header">
    <img class="brand-maskot" [src]="assets.brandMascot" alt="Logo ViaVarejo" />
    <img class="brand" [src]="assets.brandVert" alt="Logo ViaVarejo" />
  </div>
  
  <div *ngIf="!isCasasBahia" class="desktop-header">
    <div class="desktop-header-content">
      <img class="brand" [src]="assets.brand" alt="Logo ViaVarejo" />
    </div>
  </div>

  <div *ngIf="isCasasBahia" class="cb-header-container">
    <div class="cb-header-content">
      <a routerLink="/" class="brand-container">
        <img src="assets/images/new-brand-cb-text.svg">
        <hr>
      </a>
  
      <a routerLink="/" class="brand-name-container">
        <div class="brand-name">
          <h1>Pagamento e renegociação</h1>
          <h2>Carnê e cartão</h2>
        </div>
      </a>
    </div>
  </div>
  
  <div class="card-container">
    <div class="card-content">
      <img *ngIf="!isCasasBahia" class="brand-maskot" [src]="assets.brandMascot" alt="Logo ViaVarejo" />

      <div class="login-card" [class.isOldFirefox]="isOldFirefox" [class.isColaboradorLogado]="">
        <div class="login-header">
          <h2 *ngIf="cadastroStep === CadastroStepEnum.SALVAR_DADOS">Cadastro</h2>
          <h2 *ngIf="cadastroStep === CadastroStepEnum.CONFIRMAR_CADASTRO">Confimar cadastro</h2>
          <h4>{{ cadastroStep === CadastroStepEnum.SALVAR_DADOS ? 'Informe os seus dados:' : 'Confirme sua senha:' }}</h4>
        </div>
      
        <app-cadastro-form
          *ngIf="cadastroStep === CadastroStepEnum.SALVAR_DADOS"
          [loading]="loading"
          (save)="salvar($event)">
        </app-cadastro-form>
      
        <app-confirmar-cadastro-form
        *ngIf="cadastroStep === CadastroStepEnum.CONFIRMAR_CADASTRO"
        [loading]="loading"
        [disableResend]="true"
        (voltar)="voltar()"
        (confirmar)="confirmarCadastro($event)">
      </app-confirmar-cadastro-form>
      </div>
    </div>
  </div>
</div>